/** Compact speed chip in the top bar; tap cycles pause -> 1x -> 2x -> 3x -> 5x. */
import { useStore } from '../store';

const CYCLE = [1, 2, 3, 5, 0] as const;

export function SpeedControl() {
  const { sim, bridge } = useStore();
  const idx = (CYCLE as readonly number[]).indexOf(sim.speed);
  const next = CYCLE[(idx + 1) % CYCLE.length];
  return (
    <button
      class="speed-chip"
      aria-label={`Game speed ${sim.speed === 0 ? 'paused' : `${sim.speed}x`}; tap for ${next === 0 ? 'pause' : `${next}x`}`}
      onClick={() => { bridge.send('time.setSpeed', { speed: next }); }}
    >{sim.speed === 0 ? 'II' : `${sim.speed}x`}</button>
  );
}
